module.exports = __webpack_public_path__ + "static/media/ic_hire.dac0924b.svg";